var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    {
      attrs: { hover: "" },
      nativeOn: {
        click: function ($event) {
          return _vm.showDetail()
        },
      },
    },
    [
      _c("v-progress-linear", {
        staticStyle: { margin: "0" },
        attrs: {
          color: _vm.ordine.progresso < 100 ? "info" : "success",
          height: "5",
          value: _vm.ordine.progresso,
        },
      }),
      _c(
        "v-avatar",
        { staticClass: "ico-stato", attrs: { size: "40" } },
        [
          _c(
            "v-icon",
            {
              class: [
                _vm.iconClassByProgress(_vm.ordine),
                "lighten-1",
                "white--text",
              ],
            },
            [_vm._v(_vm._s(_vm._f("statoOrdineIco")(_vm.ordine.stato)))]
          ),
        ],
        1
      ),
      _vm.ordine.note && _vm.ordine.note.length > 0
        ? _c(
            "v-tooltip",
            { attrs: { bottom: "" } },
            [
              _c(
                "v-icon",
                {
                  staticClass: "ico-stato",
                  attrs: {
                    slot: "activator",
                    size: "40",
                    color: "yellow darken-1",
                    dark: "",
                  },
                  slot: "activator",
                },
                [_vm._v("mdi-note")]
              ),
              _c("span", [_vm._v(_vm._s(_vm.ordine.note))]),
            ],
            1
          )
        : _vm._e(),
      _c("v-card-text", [
        _c("h3", { staticClass: "headline mb-0" }, [
          _vm._v(
            "Num. " +
              _vm._s(_vm.ordine.ordineNumero) +
              " / " +
              _vm._s(_vm.ordine.ordineLinea)
          ),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("DATA ORDINE: "),
          _c("strong", [
            _vm._v(_vm._s(_vm._f("formatDate")(_vm.ordine.dataOrdine))),
          ]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("STATO: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.statoAs400))]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("STAGIONE: "),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.ordine.stagione.id) +
                " " +
                _vm._s(_vm.ordine.stagione.descrizione)
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-truncate" }, [
          _vm._v("MODELLO: "),
          _c("strong", [
            _vm._v(
              _vm._s(_vm.ordine.modello.codiceParte) +
                " - " +
                _vm._s(_vm.ordine.modello.descrizione)
            ),
          ]),
        ]),
        _vm.ordine.lineaVendita
          ? _c("div", { staticClass: "text-truncate" }, [
              _vm._v("LINEA DI VENDITA: "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.ordine.lineaVendita.id) +
                    " - " +
                    _vm._s(_vm.ordine.lineaVendita.descrizione)
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("v-card-text", [
        _c("div", [
          _vm._v(_vm._s(_vm.ordine.campionario ? "CAMPIONARIO" : "PRODUZIONE")),
          _vm.ordine.firstCost == "S"
            ? _c("span", [_c("strong", [_vm._v(" USA")])])
            : _vm._e(),
        ]),
        _c("div", [
          _vm._v("DATA SCADENZA: "),
          _c("strong", [
            _vm._v(_vm._s(_vm._f("formatDate")(_vm.ordine.dataScadenza))),
          ]),
        ]),
        _c("div", [
          _vm._v("RIGHE CONSEGNA: "),
          _c("strong", [_vm._v(_vm._s(_vm.ordine.lavorazioni.length))]),
        ]),
        _c("div", [
          _vm._v("NUMERO CAPI: "),
          _c("strong", [_vm._v(_vm._s(_vm.numCapiTotali))]),
        ]),
      ]),
      _vm.ordine.datiAggiuntivi && _vm.ordine.datiAggiuntivi.length > 0
        ? _c(
            "v-card-text",
            _vm._l(_vm.ordine.datiAggiuntivi, function (da, i) {
              return da.value
                ? _c(
                    "v-chip",
                    {
                      key: da.name,
                      class: [
                        _vm.getChipColorByHashedString(da.name),
                        "lighten-3",
                      ],
                      staticStyle: {
                        "margin-right": "0.25rem",
                        "margin-bottom": "0.2rem",
                      },
                      attrs: { label: "", small: "" },
                    },
                    [
                      _vm._v(" " + _vm._s(da.displayName) + ": "),
                      da.metadataType == _vm.metadataType.Datetime
                        ? _c("strong", [
                            _vm._v(_vm._s(_vm._f("formatDate")(da.value))),
                          ])
                        : _c("strong", [_vm._v(_vm._s(da.value))]),
                    ]
                  )
                : _vm._e()
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }